import { put, call, all, takeLatest } from "redux-saga/effects";

import {
  PENDING_DEBRIEF_SURVEY,
  DEBRIEF_SURVEY,
  SG_DEBRIEF_SURVEY,
  ADD_EMPLOYEE_TO_DEBRIEF_SURVEY,
  SG_ADD_EMPLOYEE_TO_DEBRIEF_SURVEY,
  VERIFY_EMPLOYEE_SURVEY,
  SG_VERIFY_EMPLOYEE_SURVEY,
  PENDING_VERIFY_EMPLOYEE,
  ALL_ERRORS,
} from "constants/actions";

import * as api from "constants/api";

function* getDebriefSurvey(action) {
  yield put({ type: PENDING_DEBRIEF_SURVEY });
  try {
    const json = yield call(api.DEBRIEF_SURVEY, action.payload);
    yield put({ type: DEBRIEF_SURVEY, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e });
  }
}

export function* loadDebriefSurvey() {
  yield takeLatest(SG_DEBRIEF_SURVEY, getDebriefSurvey);
}

function* addEmployeeToDebrief(action) {
  yield put({ type: PENDING_DEBRIEF_SURVEY });
  try {
    const json = yield call(api.ADD_EMPLOYEE_TO_DEBRIEF_SURVEY, action.payload);
    yield put({ type: ADD_EMPLOYEE_TO_DEBRIEF_SURVEY, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e });
  }
}

export function* postEmployeeToDebrief() {
  yield takeLatest(SG_ADD_EMPLOYEE_TO_DEBRIEF_SURVEY, addEmployeeToDebrief);
}

function* verifyEmployeeSurvey(action) {
  yield put({ type: PENDING_VERIFY_EMPLOYEE });
  try {
    const json = yield call(api.VERIFY_EMPLOYEE_SURVEY, action.payload);
    yield put({ type: VERIFY_EMPLOYEE_SURVEY, payload: json.data });
  } catch (e) {
    yield put({ type: ALL_ERRORS, message: e });
    yield put({ type: VERIFY_EMPLOYEE_SURVEY, payload: null });
  }
}

export function* verifyEmployee() {
  yield takeLatest(SG_VERIFY_EMPLOYEE_SURVEY, verifyEmployeeSurvey);
}

export default function* index() {
  yield all([loadDebriefSurvey(), postEmployeeToDebrief(), verifyEmployee()]);
}
